import { useMutation } from "@tanstack/react-query";
import API from "@/api";


function useCountFragments() {
  const { mutate, isPending, error } = useMutation({
    mutationFn: async (image: File) => {

      return API.countFragments(image);
    },
  });

  return {
    countFragments: mutate,
    isPending,
    error
  };
}

export default useCountFragments;
